import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { getPrivacyPolicy } from "../../reduxStore/action/configurationSettingAction";
import { handleDetailResponse, seo } from "../../utils/utils";
import "../termAndcondition/Terms.css";

const PRIVACY_SECTIONS = [
  { id: "1", titleKey: "privacySection1Title", bodyKey: "privacySection1Body" },
  { id: "2", titleKey: "privacySection2Title", bodyKey: "privacySection2Body" },
  { id: "3", titleKey: "privacySection3Title", bodyKey: "privacySection3Body" },
  { id: "4", titleKey: "privacySection4Title", bodyKey: "privacySection4Body" },
  { id: "5", titleKey: "privacySection5Title", bodyKey: "privacySection5Body" },
  { id: "6", titleKey: "privacySection6Title", bodyKey: "privacySection6Body" },
  { id: "7", titleKey: "privacySection7Title", bodyKey: "privacySection7Body" },
];

const hasMeaningfulHtml = (html) => {
  if (!html || typeof html !== "string") return false;
  const text = html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  return text.length > 0;
};

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openId, setOpenId] = useState("1");
  const [privacyData, setPrivacyData] = useState({});

  const PrivacyPolicySelector = useSelector(
    (state) => state.configurationSettingDetail
  );

  useEffect(() => {
    dispatch(getPrivacyPolicy());
  }, [dispatch]);

  useEffect(() => {
    if (PrivacyPolicySelector?.result?.data) {
      setPrivacyData(
        handleDetailResponse(PrivacyPolicySelector.result.data) || {}
      );
    }
  }, [PrivacyPolicySelector]);

  useEffect(() => {
    seo({
      title: "Privacy Policy",
      metaDescription: "Privacy policy",
      canonicalLink: window.location.href,
    });
  }, []);

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/login");
  };

  const toggleSection = (id) => {
    setOpenId((current) => (current === id ? "" : id));
  };

  const apiHtml = privacyData?.text;
  const showCmsContent = hasMeaningfulHtml(apiHtml);

  return (
    <Fragment>
      <div className="justo-terms-page">
        <div className="justo-terms">
          <div className="justo-terms__backdrop" aria-hidden="true">
            <div className="justo-terms__backdrop-grid" />
          </div>

          <div className="justo-terms__shell">
            <div className="justo-terms__card">
              <div className="justo-terms__brand-row">
                <img
                  className="justo-terms__brand"
                  src="/assets/images/JUSTOLOGO.jpg"
                  alt="Justo"
                />
              </div>

              <div className="justo-terms__intro">
                <h1 className="justo-terms__title">
                  {strings.privacyPageTitle}
                </h1>
                <p className="justo-terms__subtitle">
                  {strings.privacyPageIntro}
                </p>
              </div>

              <div className="justo-terms__overview">
                <p className="justo-terms__overview-label">
                  {strings.privacyOverviewTitle}
                </p>
                <p className="justo-terms__overview-body">
                  {strings.privacyOverviewBody}
                </p>
              </div>

              {showCmsContent ? (
                <div
                  className="justo-terms__prose"
                  dangerouslySetInnerHTML={{ __html: apiHtml }}
                />
              ) : (
                <div className="justo-terms__accordion">
                  {PRIVACY_SECTIONS.map((section) => {
                    const isOpen = openId === section.id;
                    return (
                      <div
                        key={section.id}
                        className={`justo-terms__item${
                          isOpen ? " is-open" : ""
                        }`}
                      >
                        <button
                          type="button"
                          className="justo-terms__item-trigger"
                          aria-expanded={isOpen}
                          onClick={() => toggleSection(section.id)}
                        >
                          <span className="justo-terms__item-label">
                            {strings[section.titleKey]}
                          </span>
                          <span
                            className="justo-terms__item-icon"
                            aria-hidden="true"
                          >
                            {isOpen ? "−" : "+"}
                          </span>
                        </button>
                        {isOpen ? (
                          <div className="justo-terms__item-panel">
                            <p>{strings[section.bodyKey]}</p>
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="justo-terms__actions">
                <button
                  type="button"
                  className="justo-terms__btn justo-terms__btn--ghost"
                  onClick={goBack}
                >
                  {strings.privacyBack}
                </button>
                <button
                  type="button"
                  className="justo-terms__btn justo-terms__btn--solid"
                  onClick={() => navigate("/termandcondition")}
                >
                  {strings.loginTermsLink}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PrivacyPolicy;
